import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { environment } from 'src/environments/environment';
import { State } from '../models/state.model';
import { CanadaProvince } from '../models/canada-province';

@Injectable({
  providedIn: 'root',
})
export class ApiService {
  private baseRoute: string;
  private headers: HttpHeaders;
  states: State[] = [
    {
      name: 'Alabama',
      abbreviation: 'AL',
    },
    {
      name: 'Alaska',
      abbreviation: 'AK',
    },
    {
      name: 'American Samoa',
      abbreviation: 'AS',
    },
    {
      name: 'Arizona',
      abbreviation: 'AZ',
    },
    {
      name: 'Arkansas',
      abbreviation: 'AR',
    },
    {
      name: 'California',
      abbreviation: 'CA',
    },
    {
      name: 'Colorado',
      abbreviation: 'CO',
    },
    {
      name: 'Connecticut',
      abbreviation: 'CT',
    },
    {
      name: 'Delaware',
      abbreviation: 'DE',
    },
    {
      name: 'District Of Columbia',
      abbreviation: 'DC',
    },
    {
      name: 'Federated States Of Micronesia',
      abbreviation: 'FM',
    },
    {
      name: 'Florida',
      abbreviation: 'FL',
    },
    {
      name: 'Georgia',
      abbreviation: 'GA',
    },
    {
      name: 'Guam',
      abbreviation: 'GU',
    },
    {
      name: 'Hawaii',
      abbreviation: 'HI',
    },
    {
      name: 'Idaho',
      abbreviation: 'ID',
    },
    {
      name: 'Illinois',
      abbreviation: 'IL',
    },
    {
      name: 'Indiana',
      abbreviation: 'IN',
    },
    {
      name: 'Iowa',
      abbreviation: 'IA',
    },
    {
      name: 'Kansas',
      abbreviation: 'KS',
    },
    {
      name: 'Kentucky',
      abbreviation: 'KY',
    },
    {
      name: 'Louisiana',
      abbreviation: 'LA',
    },
    {
      name: 'Maine',
      abbreviation: 'ME',
    },
    {
      name: 'Marshall Islands',
      abbreviation: 'MH',
    },
    {
      name: 'Maryland',
      abbreviation: 'MD',
    },
    {
      name: 'Massachusetts',
      abbreviation: 'MA',
    },
    {
      name: 'Michigan',
      abbreviation: 'MI',
    },
    {
      name: 'Minnesota',
      abbreviation: 'MN',
    },
    {
      name: 'Mississippi',
      abbreviation: 'MS',
    },
    {
      name: 'Missouri',
      abbreviation: 'MO',
    },
    {
      name: 'Montana',
      abbreviation: 'MT',
    },
    {
      name: 'Nebraska',
      abbreviation: 'NE',
    },
    {
      name: 'Nevada',
      abbreviation: 'NV',
    },
    {
      name: 'New Hampshire',
      abbreviation: 'NH',
    },
    {
      name: 'New Jersey',
      abbreviation: 'NJ',
    },
    {
      name: 'New Mexico',
      abbreviation: 'NM',
    },
    {
      name: 'New York',
      abbreviation: 'NY',
    },
    {
      name: 'North Carolina',
      abbreviation: 'NC',
    },
    {
      name: 'North Dakota',
      abbreviation: 'ND',
    },
    {
      name: 'Northern Mariana Islands',
      abbreviation: 'MP',
    },
    {
      name: 'Ohio',
      abbreviation: 'OH',
    },
    {
      name: 'Oklahoma',
      abbreviation: 'OK',
    },
    {
      name: 'Oregon',
      abbreviation: 'OR',
    },
    {
      name: 'Palau',
      abbreviation: 'PW',
    },
    {
      name: 'Pennsylvania',
      abbreviation: 'PA',
    },
    {
      name: 'Puerto Rico',
      abbreviation: 'PR',
    },
    {
      name: 'Rhode Island',
      abbreviation: 'RI',
    },
    {
      name: 'South Carolina',
      abbreviation: 'SC',
    },
    {
      name: 'South Dakota',
      abbreviation: 'SD',
    },
    {
      name: 'Tennessee',
      abbreviation: 'TN',
    },
    {
      name: 'Texas',
      abbreviation: 'TX',
    },
    {
      name: 'Utah',
      abbreviation: 'UT',
    },
    {
      name: 'Vermont',
      abbreviation: 'VT',
    },
    {
      name: 'Virgin Islands',
      abbreviation: 'VI',
    },
    {
      name: 'Virginia',
      abbreviation: 'VA',
    },
    {
      name: 'Washington',
      abbreviation: 'WA',
    },
    {
      name: 'West Virginia',
      abbreviation: 'WV',
    },
    {
      name: 'Wisconsin',
      abbreviation: 'WI',
    },
    {
      name: 'Wyoming',
      abbreviation: 'WY',
    },
  ];

  canadaProvinces: CanadaProvince[] = [
    {
      Province: "Alberta",
      Code: "AB"
    },
    {
      Province: "British Columbia",
      Code: "BC"
    },
    {
      Province: "Manitoba",
      Code: "MB"
    },
    {
      Province: "New Brunswick",
      Code: "NB"
    },
    {
      Province: "Newfoundland and Labrador",
      Code: "NL"
    },
    {
      Province: "Northwest Territories",
      Code: "NT"
    },
    {
      Province: "Nova Scotia",
      Code: "NS"
    },
    {
      Province: "Nunavut",
      Code: "NU"
    },
    {
      Province: "Ontario",
      Code: "ON"
    },
    {
      Province: "Prince Edward Island",
      Code: "PE"
    },
    {
      Province: "Quebec",
      Code: "QC"
    },
    {
      Province: "Saskatchewan",
      Code: "SK"
    },
    {
      Province: "Yukon",
      Code: "YT"
    }
]

  constructor(private httpClient: HttpClient) {
    this.baseRoute = environment.apiRoot + 'api/';
    this.headers = new HttpHeaders();
  }

  get route() {
    return this.baseRoute;
  }

  setHeader(key: string, value: string) {
    if (this.headers.has(key)) {
      this.headers = this.headers.set(key, value);
    } else {
      this.headers = this.headers.append(key, value);
    }
  }

  removeHeader(key: string) {
    this.headers = this.headers.delete(key);
  }

  get<T>(route: string): Observable<T> {
    return this.httpClient.get<T>(`${this.baseRoute}${route}`, {
      headers: this.headers,
    });
  }

  post<T>(route: string, payload: any = null): Observable<T> {
    return this.httpClient.post<T>(`${this.baseRoute}${route}`, payload, {
      headers: this.headers,
    });
  }

  put<T>(route: string, payload: any = null): Observable<T> {
    return this.httpClient.put<T>(`${this.baseRoute}${route}`, payload, {
      headers: this.headers,
    });
  }

  delete<T>(route: string): Observable<T> {
    return this.httpClient.delete<T>(`${this.baseRoute}${route}`, {
      headers: this.headers,
    });
  }

  // usaStates<T>(): Observable<T> {
  //   return this.httpClient.get<T>(
  //     `https://www.mocky.io/v2/5e8b3dfc2d0000271a1a4dcd`
  //   );
  // }
  usaStates() {
    return of(this.states);
  }

  canProvinces() {
    return of(this.canadaProvinces);
  }
}
